import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components';
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupButtonLink = ({ url, children, onClick }) => (
  <Link href={url} className={cx('btn-link')} variant="button" onClick={onClick}>{children}</Link>
);

PopupButtonLink.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.func,
};
